'use strict';
const angular = require('angular');

export class publicNewsFeedComponent {

  constructor(NewsService, IntegrationService, Config) {
    'ngInject';

    this.NewsService = NewsService;
    this.Config = Config;
    this.currentPage = 1;
  }

  $onInit() {

    let convertShortcode = (html) => {
      return html.replace(/\[/g,"<").replace(/\]/g,">");
    };

    this.itemsPerPage = this.Config.getPaginationWithDefault("featuredPublicNews", 3);
    
    this.NewsService.getPublic(data => {
      data.forEach(news => {
        news.body = convertShortcode(news.body);
      });

      this.data = data;

    }, err => {
      console.log('could not load public featured news');
    });

  }
}

export default angular.module('conduuApp.publicNewsFeed', [])
  .component('publicNewsFeed', {
    template: require('./public-news-feed.component.html'),
    bindings: {},
    controller: publicNewsFeedComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/public-news-feed/public-news-feed.component.js